import { render } from "./CommonHomeTop.vue?vue&type=template&id=337ae55c&scoped=true"
import script from "./CommonHomeTop.vue?vue&type=script&lang=js"
export * from "./CommonHomeTop.vue?vue&type=script&lang=js"

import "./CommonHomeTop.vue?vue&type=style&index=0&id=337ae55c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-337ae55c"],['__file',"src/views/h5/common/home/components/top/CommonHomeTop.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "337ae55c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('337ae55c', __exports__)) {
    api.reload('337ae55c', __exports__)
  }
  
  module.hot.accept("./CommonHomeTop.vue?vue&type=template&id=337ae55c&scoped=true", () => {
    api.rerender('337ae55c', render)
  })

}


export default __exports__